module.exports = __webpack_public_path__ + "workspace/static/img/tenantMgmtOne.f7fafda.png";